import React from 'react';
import Header from '../../Components/Header/Navbar';

const ShoppingCart = () => {
  return (
    <>
    <Header/>
    </>
  );
};

export default ShoppingCart;